import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from '../../Components/Button'
import Grid from '@mui/material/Unstable_Grid2'


import { useTheme } from '@mui/material'
import { useAppDispatch } from 'src/app/hooks';
import { toggleModal } from './logoutSlicer';
import { logout }  from '../Login/store/login.Slice'

import { useNavigate } from 'react-router-dom';

interface ownProps {
    open: boolean;
}
const LogoutModal : React.FC<ownProps> = ({ open }: ownProps) => {

  const theme = useTheme()
  const dispatch = useAppDispatch();
  const navigate = useNavigate()

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 605,
    height: 327,
    bgcolor: '#212121',
    border: '4px 4px 8px rgba(0, 0, 0, 0.25)',
    borderRadius: "20px",
    boxShadow: 24,
    display: "flex",
    alignItems:"center",
    flexDirection: "column",
    p: 4,
    [theme.breakpoints.down('sm')]: {
      width: 385,
      fontSize: 24
    }
  };
  const buttonStyle = {
    ":hover": {
      color: "white"
    }
  }
  const handleClose = () => {
    dispatch(toggleModal(false))
  }
  const handleLogout = () => {
    dispatch(logout())
    navigate('/', {replace: true})
  }
  return (
    <div>
      <Modal
    
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
            
          <Grid container spacing={2}>
            <Grid sx={{ width: "100%"}}>
              <Typography sx={{ fontSize: "40px", fontWeight: 400, textAlign:"center"}} id="modal-modal-title" variant="h6" component="h2">
                Logout
            </Typography>
            </Grid>
            
            <Grid sx={{ width: "100%"}}>
              <Typography sx={{ fontSize: "24px", fontWeight: 400,  mt: 2 , textAlign:"center",  lineHeight: "33px"}} id="modal-modal-description" >
                Are you sure you want to logout from   the control system?
              </Typography>
            </Grid>

            <Grid sx={{ width: "100%", mt: '16px'}} display={"flex"} justifyContent="space-around" >
              <Button onClick={() => handleClose()} sx={{...buttonStyle, width: 157, height:58, backgroundColor: "#D4DD06"}} variant='contained' name='Cancel' />
              <Button onClick={handleLogout} sx={{...buttonStyle, width: 157, height:58,backgroundColor: "#FFFFFF"}} variant='contained' name='Logout' />
            </Grid>

          </Grid>
        
      
         
        
        </Box>
      </Modal>
    </div>
  );
}
export default LogoutModal